export type OpenDrawer = 'left' | 'right' | 'none'

export enum LeftDrawerContent {
  Default = 'default',
}

export enum RightDrawerContent {
  AuditLog = 'audit-log',
  Communication = 'communication',
}

export type DrawerState =
  | {
      direction: 'left'
      content: LeftDrawerContent
    }
  | {
      direction: 'right'
      content: RightDrawerContent
    }
  | {
      direction: 'initial'
      content: ''
    }
  | {
      direction: 'none'
      content: 'default'
    }
